import React from 'react';
import '../styles/compsStyles/alertAsk.css'

const AlertAsk = props =>{
  return(
    <div className='alertAskBackground' onClick={props.no}>
    <div className='alertAsk' onClick={event => event.stopPropagation()}>
      <h1>{props.title}</h1>
      <div className='alertAskButtons'>
        <button type="button" onClick={props.okay}>{props.okayLabel || 'okay'}</button>
        {props.no && <button type="button" onClick={props.no}>{props.noLabel || 'no'}</button>}
      </div>
    </div>
  </div>
  )
}

export default AlertAsk;
